import { useState } from "react";
import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import AiInvoiceBanner from "./../../assets/images/banner/enterprise.png";
import { Link } from "react-router-dom";
import service1 from "./../../assets/images/banner/notification.jpg";
import service2 from "./../../assets/images/banner/customer-support.jpg";
import service3 from "./../../assets/images/banner/food-ord.jpg";
import service4 from "./../../assets/images/banner/ia.jpg";


const Wa_Enterprise = () => {
  pageTitle("WhatsApp AI For Enterprise");

  return (
    <>
      <HeaderOne />

      <div
        className="ai-overlay-wrapper-solutions"
        style={{ backgroundImage: `url(${AiInvoiceBanner})` }}
      >
        <div className="ai-overlay">
          <div className="ai-overlay-center-project-text-solutions">
            <h2 className="ai-overlay-project enterprise-h2">
              Secure, Single-Tenant WhatsApp API <br />
              for Enterprise Systems
            </h2>
          </div>
          <div className="siw-hero-price-box-sol">
            
            <Link
              to="/contact"
              className="theme-btn theme-btn-one siw-hero-small-btn"
            >
              TALK TO US
            </Link>
          </div>
        </div>
      </div>

      <section className="py-3 py-md-4">
        <div className="container">
          {/* <h3 className="siw-project-heading">
            One WhatsApp message is all it takes, automate your grocery orders instantly.
          </h3> */}

          <div className="row g-4 align-items-stretch">
            <div className="col-lg-12 d-flex">
              <div className="food-grey-box w-100">
                <h3 className="siw-project-heading pb-1">
                  Safe & Secure — Your Data Stays in Your Environment
                </h3>
                <p className="mb-0 siw-rpa-desc">
                  Deploy WhatsApp Business API in your own server environment,
                  private cloud, or internal infrastructure — without relying on
                  shared application layers or opaque third-party tooling.
                </p>
                <p className="siw-rpa-desc">
                  With a single-tenant deployment model, your organization can
                  maintain:
                </p>
                <div className="siw-rpa-desc">
                  <ul>
                    <li>
                      Conversation data within your controlled environment
                    </li>
                    <li>
                      Internal governance over access control, logging, and
                      audit policies
                    </li>
                    <li>
                      Reduced exposure to shared infrastructure and third-party
                      inbox risks
                    </li>
                    <li>
                      Greater control over how WhatsApp integrates with your
                      internal systems
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="wa-zigzag-section">
        <div className="container">
          {/* 1 */}
          <div className="wa-zigzag-row">
            <div className="wa-zigzag-image">
              <img src={service1} alt="Official WhatsApp Business API setup" />
            </div>

            <div className="wa-zigzag-content">
              <h3>
                Official WhatsApp Business API Setup for Reliable Customer
                Engagement
              </h3>

              <p>
                Launch your WhatsApp Business API with the right setup, approval
                guidance, messaging flow, and compliance-ready configuration. We
                help businesses use WhatsApp for customer enquiries, promotions,
                notifications, reminders, and automated support.
              </p>

              <p>
                A proper foundation helps reduce setup mistakes, message
                delivery issues, and policy-related risks while keeping your
                WhatsApp channel stable and business-ready.
              </p>

              <a href="/contact" className="siw-rpa-btn">
                TALK TO US
              </a>
            </div>
          </div>

          {/* 2 */}
          <div className="wa-zigzag-row reverse">
            <div className="wa-zigzag-image">
              <img src={service2} alt="WhatsApp automation and AI chatbot" />
            </div>

            <div className="wa-zigzag-content">
              <h3>
                WhatsApp Automation for Sales, Support, Orders, and Follow-ups
              </h3>

              <p>
                Turn WhatsApp into an automated business channel for customer
                chats, order confirmations, reminders, support replies, lead
                capture, and follow-up messages. Your workflows can be connected
                with your CRM, website, backend system, or business dashboard.
              </p>

              <p>
                Start with simple automation and expand into AI-powered
                conversations, document capture, order handling, and customer
                service flows as your business grows.
              </p>

              <a href="/contact" className="siw-rpa-btn">
                TALK TO US
              </a>
            </div>
          </div>

          {/* 3 */}
          <div className="wa-zigzag-row">
            <div className="wa-zigzag-image">
              <img src={service3} alt="Private WhatsApp architecture" />
            </div>

            <div className="wa-zigzag-content">
              <h3>
                Secure WhatsApp Architecture Designed Around Your Business
                Systems
              </h3>

              <p>
                Build a WhatsApp solution that fits your internal process, data
                flow, and security requirements. We design private and
                structured architectures for businesses that need better control
                over customer conversations, integrations, logs, and reporting.
              </p>

              <p>
                Suitable for companies that want a scalable WhatsApp setup for
                marketing, operations, customer service, ordering, attendance,
                invoicing, and AI automation.
              </p>

              <a href="/contact" className="siw-rpa-btn">
                TALK TO US
              </a>
            </div>
          </div>

          {/* 4 */}
          <div className="wa-zigzag-row reverse">
            <div className="wa-zigzag-image">
              <img src={service4} alt="Enterprise WhatsApp implementation" />
            </div>

            <div className="wa-zigzag-content">
              <h3>
                End-to-End WhatsApp Implementation with AI, Dashboard, and
                Integration
              </h3>

              <p>
                We help you plan, build, and deploy WhatsApp solutions based on
                your business use case. From chatbot flows and template messages
                to AI agents, order dashboards, invoice automation, attendance
                tracking, and reporting, everything is designed around your
                workflow.
              </p>

              <p>
                Our goal is to help you create a WhatsApp channel that improves
                response time, reduces manual work, and supports measurable
                business growth.
              </p>

              <a href="/contact" className="siw-rpa-btn">
                TALK TO US
              </a>
            </div>
          </div>
        </div>
      </section>

     

      <FooterOne />
    </>
  );
};

export default Wa_Enterprise;
